app.controller("QuestionnairesHistoryController", ["$scope", "$stateParams", "QuestionnairesService", "StaticData", "$uibModal", "$state", "ConfirmModal", "toastr", "usSpinnerService",
    function ($scope, $stateParams, QuestionnairesService, StaticData, $uibModal, $state, ConfirmModal, toastr, usSpinnerService) {
        $scope.format = 'dd-MM-yyyy HH:mm';
        $scope.questionnaires = null;
        $scope.totalItems = 0;
        $scope.itemsPerPage = 10;
        $scope.title = $stateParams.title;
        $scope.template = $stateParams.template;
        $scope.query = $stateParams.query;
        $scope.fromDate = $stateParams.fromDate ? new Date(parseInt($stateParams.fromDate)) : undefined;
        $scope.toDate = $stateParams.toDate ? new Date(parseInt($stateParams.toDate)) : undefined;
        $scope.owned = $stateParams.owned === 'true';
        $scope.filterType = $stateParams.type || null;
        $scope.filterTypes = [];

        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        $scope.openFromDate = function () {
            $scope.popup1.opened = true;
        };

        $scope.openToDate = function () {
            $scope.popup2.opened = true;
        };

        loadPage($stateParams.page, $scope.query, $scope.fromDate, $scope.toDate, function () {
        });

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levelsMap = _.keyBy(levels, '_id');
        });

        StaticData.getItemsByKey("states").then(function (states) {
            $scope.statesMap = _.keyBy(states, '_id');
        });

        StaticData.getItemsByKey("subject_seasons").then(function (seasons) {
            $scope.seasonsMap = _.keyBy(seasons, '_id');
        });

        StaticData.getItemsByKey("questionnaire_filter_types").then(function (types) {
            $scope.filterTypes = [{ name: "ფილტრის ტიპი" }].concat(types);
            $scope.filterTypesMap = _.keyBy(types, '_id');
        });

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{ name: "ფაკულტეტი" }].concat(faculties);
            $scope.facultiesMap = _.keyBy(faculties, '_id');
        });

        $scope.goToPage = function (page) {
            $state.go(".", { page: page });
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.editQuestionnaires = function (questionnaire) {
            $state.go("admin.questionnaires.create", {
                operationType: 'edit',
                questionnaireId: questionnaire._id
            });
        };

        $scope.resendQuestionnaire = function (questionnaire) {
            $state.go("admin.questionnaires.send", {
                questionnaireId: questionnaire._id,
            });
        };

        $scope.remove = function (questionnaire, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "ყურადღება",
                message: "გსურთ კითხვარის წაშლა ?"
            }).result.then(function () {
                QuestionnairesService.deleteTemplate(questionnaire._id).then(function () {
                    loadPage();
                    toastr.success('', 'კითხვარი წაშლილია');
                });
            });
        };

        $scope.getStatistics = function (questionnaire, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            QuestionnairesService.exportStatistics(questionnaire._id)
        };

        $scope.editParams = function (questionnaire, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "EditQuestionnaireParamsWindowController",
                templateUrl: _pb + 'admin/questionnaires/edit-questionnaire-params-window.html',
                size: "md",
                windowClass: 'max-window',
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            questionnaire: questionnaire
                        };
                    }
                }
            }).result
                .then(function () {
                    toastr.success('', 'კითხვარის პარამეტრები რედაქტირებულია');
                    setTimeout(function () {
                        loadPage($stateParams.page, $scope.query, $scope.fromDate, $scope.toDate);
                    }, 500);
                });
        }

        function loadPage(page, query, fromDate, toDate, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            $scope.currentPage = $stateParams.page;
            QuestionnairesService.list({
                limit: 1000,
                template: $scope.template,
                query: $scope.query,
                fromDate: $scope.fromDate ? $scope.fromDate.getTime() : undefined,
                toDate: $scope.toDate ? $scope.toDate.getTime() : undefined,
                type: $scope.filterType
            }).then(function (result) {
                $scope.questionnaires = result;
                $scope.totalItems = result.length;
                usSpinnerService.stop("root");
                cb();
            }, function (err) {
                console.log('--err--', err);
            });
        }

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                fromDate: $scope.fromDate ? $scope.fromDate.getTime() : undefined,
                toDate: $scope.toDate ? $scope.toDate.getTime() : undefined,
                type: $scope.filterType
            });
        };
    }
]);
